import { useGetBreakpoints } from './breakpoints';

export const DesktopContainer = ({ children }) => {
    const { isDesktop } = useGetBreakpoints();
    return isDesktop ? children : null
}

export const TabletContainer = ({ children }) => {
    const { isTablet } = useGetBreakpoints();
    return isTablet ? children : null
}

export const MobileContainer = ({ children }) => {
    const { isMobile } = useGetBreakpoints();
    return isMobile ? children : null
}

export const DesktopOrTabletContainer = ({ children }) => {
    const { isDesktop, isTablet } = useGetBreakpoints();
    return (isDesktop || isTablet) ? children : null
}
